import Header from '@/components/Header'
import Hero from '@/components/Hero'
import MaxGamesSection from '@/components/MaxGamesSection'
import StatsSection from '@/components/StatsSection'
import FeaturesSection from '@/components/FeaturesSection'
import CTASections from '@/components/CTASections'
import Footer from '@/components/Footer'
import {LanguageProvider} from '@/contexts/LanguageContext'

function Home() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-black text-white overflow-x-hidden">
        <div
          className="fixed inset-0 pointer-events-none"
          style={{
            background:
              'radial-gradient(circle at 50% 0%, rgba(99,102,241,0.22), transparent 55%)',
          }}
        />
        <div className="relative">
          <Header />
          <Hero />
          <MaxGamesSection />
          <StatsSection />
          <FeaturesSection />
          <CTASections />
          <Footer />
        </div>
      </div>
    </LanguageProvider>
  )
}

export default Home
